export default {
    firstToCreate: 'Bu forumda ilk konuyu oluşturun',
    firstToPostInCategory: 'Bu kategoride ilk gönderiyi yapın',
    firstToRespondToTopic: 'Bu konuya ilk yanıtı siz verin!',
    createNewThread: 'Yeni konu oluştur',
    thread: 'konu',
    viewThread: 'Konuyu görüntüle',
    replies: 'Yanıtlar',
    noReplies: 'Yanıt yok',
    reply: 'yanıt',
    _reply: 'Yanıtla',
    ReplyTo: 'Yanıtla',
    replyToThisQuestion: 'Bu soruya yanıt ver',
    onceRepliedModeratorMayRespond: 'Yanıt verdikten sonra, forum moderatörü yanıtınıza cevap verebilir',
    onceRepliedCanViewResponses: 'Yanıt verdikten sonra diğer katılımcıların yanıtlarını görebilirsiniz',
    loadingResponses: 'Yanıtlar yükleniyor',
    hideXReplies: '{count} yanıtı gizle',
    showXReplies: '{count} yanıtı göster',
    hideMostRecentReplies: 'En son yanıtları gizle',
    showMostRecentReplies: 'En son yanıtları göster',
    post: 'Gönderi',
    message: 'Mesaj',
    typeMessage: 'Mesaj yaz',
    addPost: 'Gönderi ekle',
    addMessage: 'Mesaj ekle',
    editPost: 'Gönderiyi düzenle',
    editPostWithMedia: 'Medya ile gönderiyi düzenle',
    createPostWithMedia: 'Medya ile gönderi oluştur',
    deleteMessage: 'Mesajı sil',
    deleteMessageConfirm: 'Bu mesajı silmek istediğinizden emin misiniz?',
    pinPost: 'Gönderiyi sabitle',
    media: 'Medya',
    uploadMedia: 'Medya yükle',
    categories: 'kategoriler',
    goBack: 'Geri dön',
    goBackPrevious: 'Önceki sayfaya geri dön',
    goBackToCategory: '{name} kategorisine geri dön',
    loadingLatestThreads: 'Son konular yükleniyor',
    loadingDiscussionForum: 'Tartışma forumu yükleniyor',
    dontShowAgainForTask: 'Bu görev için tekrar gösterme',
    title: 'Başlık',
    beTheFirst: 'Bu konuya ilk yanıt veren siz olun'
};
